import React from "react";
import CSSClasses from "./SettingsLive.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import beepHigh from "../../../assets/sounds/beep_high.mp3";

const SettingsLive = props => {
  let oddFormats = [
    {
      id: 1,
      name: "US",
      example: "+120"
    },
    {
      id: 5,
      name: "UK",
      example: "6/5"
    },
    {
      id: 0,
      name: "Decimal",
      example: "2.20"
    },
    {
      id: 4,
      name: "Hong Kong",
      example: "1.20"
    },
    {
      id: 3,
      name: "Indonesian",
      example: "1.20"
    },
    {
      id: 2,
      name: "Malay",
      example: "-0.835"
    }
  ];

  let sorts = [
    {
      id: 1,
      name: "Vrijeme",
      desc: "silazno"
    },
    {
      id: 2,
      name: "Vrijeme",
      desc: "uzlazno"
    },
    {
      id: 3,
      name: "Lige A-Z",
      desc: ""
    }
  ];

  //definiraj klase
  let containerClasses = [CSSClasses.container];

  if (props.currentThemeID === 2) {
    //light
    containerClasses.push(CSSClasses.lightTheme);
  }

  return (
    <div className={containerClasses.join(" ")}>
      <audio
        ref={sound => {
          this.beepHigh = sound;
        }}
      >
        <source src={beepHigh} type="audio/mpeg" />
      </audio>

      <div className={CSSClasses.activeDiv}>&nbsp;</div>

      <div style={{ clear: "both", height: "0px" }}>&nbsp;</div>

      {/* <div className={CSSClasses.firstRow}>
        <span className={CSSClasses.lblTitle}>Dark Theme</span>

        <div className={CSSClasses.onoffswitch}>
          <input
            type="checkbox"
            name="chkTheme"
            className={CSSClasses.onoffswitch_checkbox}
            id="chkTheme"
            checked={props.currentThemeID === 1} //tamna tema
            onChange={(e, data) => chkTheme_Change(e, data, props)}
          />
          <label className={CSSClasses.onoffswitch_label} htmlFor="chkTheme" />
        </div>
      </div> */}

      <div className={CSSClasses.secondRow}>
        <span className={CSSClasses.lblTitle}>Tema</span>
      </div>

      <div className={CSSClasses.thirdRow}>
        <div
          className={[
            CSSClasses.buttonBoxSingle,
            props.currentThemeID === 2 ? CSSClasses.active : ""
          ].join(" ")}
          onClick={() => props.changeLiveTheme(2)}
        >
          <span className={CSSClasses.btnTitle}>Svijetlo</span>
          <br />
        </div>
        <div
          className={[
            CSSClasses.buttonBoxSingle,
            props.currentThemeID === 1 ? CSSClasses.active : ""
          ].join(" ")}
          onClick={() => props.changeLiveTheme(1)}
        >
          <span className={CSSClasses.btnTitle}>Tamno</span>
          <br />
        </div>
      </div>

      <div className={CSSClasses.secondRow}>
        <span className={CSSClasses.lblTitle}>Format kvota</span>
      </div>

      <div className={CSSClasses.thirdRow}>
        {oddFormats.map(of => {
          let classes = [CSSClasses.buttonBox];

          if (props.currentThemeID === 2) {
            //light
            classes.push(CSSClasses.lightThemeButton);
          }

          if (of.id === props.currentOddFormat) {
            classes.push(CSSClasses.active);
          }

          return (
            <div
              className={classes.join(" ")}
              key={of.id}
              onClick={() => btnOddFormat_Click(props, of.id)}
            >
              <span className={CSSClasses.btnTitle}>{of.name}</span>
              <br />
              <span className={CSSClasses.btnSubtitle}>{of.example}</span>
            </div>
          );
        })}
      </div>

      <div className={CSSClasses.secondRow}>
        <span className={CSSClasses.lblTitle}>Sort Live Utakmica</span>
      </div>

      <div className={CSSClasses.thirdRow}>
        {sorts.map(sort => {
          let classes = [
            sort.desc === "" ? CSSClasses.buttonBoxSingle : CSSClasses.buttonBox
          ];

          if (props.currentThemeID === 2) {
            //light
            classes.push(CSSClasses.lightThemeButton);
          }

          if (sort.id === props.currentSortType) {
            classes.push(CSSClasses.active);
          }

          return (
            <div
              className={classes.join(" ")}
              key={sort.id}
              onClick={() => changeSortType(props, sort.id)}
            >
              <span className={CSSClasses.btnTitle}>{sort.name}</span>
              <br />
              <span className={CSSClasses.btnSubtitle}>{sort.desc}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// const chkTheme_Change = (e, data, props) => {
//   console.log("change ", e.target.checked);

//   props.changeLiveTheme(e.target.checked ? 1 : 2);
// };

const btnOddFormat_Click = (props, oddFormatID) => {
  //alert("CLOSE");
  if (this.beepHigh) {
    this.beepHigh.play();
  }

  props.changeOddFormat(oddFormatID);
};

const changeSortType = (props, sortID) => {
  //alert("CLOSE");
  if (this.beepHigh) {
    this.beepHigh.play();
  }

  props.changeSortType(sortID);
};

const mapStateToProps = state => {
  return {
    currentOddFormat: state.rrAppState.oddFormatID,
    currentThemeID: state.rrAppState.currentActiveLiveTheme,
    currentSortType: state.rrAppState.sortTypeID
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeOddFormat: oddFormat =>
      dispatch(StoreActions.SetOddFormat(oddFormat, true)),
    changeSortType: sortID => dispatch(StoreActions.SetSortType(sortID, true)),
    changeLiveTheme: themeID =>
      dispatch(StoreActions.SetLiveTheme(themeID, true))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsLive);



// WEBPACK FOOTER //
// ./src/Components/Navigation/SettingsLive/SettingsLive.js